export const floatingWidgetVariant = {
  variants: { 
      fadeIn: { opacity: 1 }, 
      fadeOut: { opacity: 0 } },
      moveUp: { y: -50, scale: 0.95 },
      moveDown: { y: 0, scale: 1 },
    variantTypes: { FADE_IN: 'fadeIn', 
                FADE_OUT: 'fadeOut',
                MOVE_UP: 'moveUp',
                MOVE_DOWN: 'moveDown' },
};
